import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        const contactLocations = document.querySelector('.contact-select-office');
        if (office) {
            // footer
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const locationMap = document.querySelector('.office-info-map');
            this.loadLocations(office, officeBox, officeHours, locationMap);
            office.addEventListener('change', () =>
                this.loadLocations(office, officeBox, officeHours, locationMap)
            );
        }

        if (contactLocations) {
            const contactOfficeBox = document.querySelector('.contact-office-info');
            const contactOfficeHours = document.querySelector(
                '.contact-opening-hours'
            );
            const contactLocationMap = document.querySelector(
                '.contact-office-info-map'
            );
            this.loadLocations(
                contactLocations,
                contactOfficeBox,
                contactOfficeHours,
                contactLocationMap,
                false
            );
            contactLocations.addEventListener('change', () =>
                this.loadLocations(
                    contactLocations,
                    contactOfficeBox,
                    contactOfficeHours,
                    contactLocationMap,
                    false
                )
            );
        }
    },

    /**
     * Load Locations
     */
    async loadLocations(
        locationID,
        officeBox,
        officeHours,
        locationMap,
        isFooter = true
    ) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHoursModal = new modals('.cw-modal');
                officeHoursModal.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    spanish_label,
                    location_fax,
                    footer_map,
                    footer_map_image_mobile,
                    contact_map,
                    contact_map_tablet,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span><br>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span><br>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">${phone}</a><br>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a href="${directionURL}" target="_blank" aria-label="Direction Link">Directions</a>
                   <button class="btn cw-modal" data-cw-target="#hoursModal" id="office-hours">Office Hours</button>
				   </div>`;
                let footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Directions Link"><img src="${footer_map}" class="d-md-none d-lg-block" alt="${firmName}" /><img class="d-none d-md-block d-lg-none" src="${footer_map_image_mobile}" alt="${firmName}" /></a></figure>` :
                    '';
                if (!isFooter) {
                    footerMapHTML = contact_map ?
                        `<figure><a href="${directionURL}" target="_blank" aria-label="Directions Link"><img src="${contact_map}" alt="${firmName}" /></a></figure>` :
                        '';
                }

                const es = `<span aria-label="Se habla español link" class="es-link">${
					spanish_label || ''
				}</span>`;

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}
               ${emailHTML}${es}${officeInfoButtons}
               `;
                officeBox.innerHTML = address;
                locationMap.innerHTML = footerMapHTML;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;